<template>
  <el-select
    v-model="location"
    filterable
    placeholder="Select a Country"
    :clearable="true"
  >
    <el-option
      v-for="item in countries"
      :key="item.countryId"
      :label="item.value"
      :value="item.countryId"
    />
  </el-select>
</template>

<script>
import countries from '@/config/datalists/countries.js'
export default {
  name: 'Location',
  computed: {
    countries() {
      return countries
    },
    location: {
      get() {
        return this.$store.getters['filters/location']
      },
      set(value) {
        value = (value === '') ? null : value
        this.$store.commit('filters/location', value)
      }
    }
  }
}
</script>
